/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
import { createSlice } from '@reduxjs/toolkit';

const systemConfigSlice = createSlice({
  name: 'systemConfigs',
  initialState: {
    shippingOptions: [],
    lineItemTags: [],
    externalPharmacy: {
      pharmacyList: null,
      loading: false,
      sortBy: {
        sortKey: 'pharmacyName',
        sortOrder: 'ASC',
      },
    },
  },
  reducers: {
    updateShippingOptions(state, action) {
      const { shippingOptions } = action.payload;

      state.shippingOptions = shippingOptions;
    },
    updateLineItemTags(state, action) {
      const { tags } = action.payload;

      state.lineItemTags = tags;
    },
    updateExternalPharmacies(state, action) {
      const { pharmacyList } = action.payload;

      state.externalPharmacy.pharmacyList = pharmacyList;
    },
    setExternalPharmaciesLoading(state, action) {
      const { loading } = action.payload;

      state.externalPharmacy.loading = loading;
    },
    updateExternalPharmaciesSortBy(state, action) {
      const { sortBy } = action.payload;

      state.externalPharmacy.sortBy = sortBy;
    },
  },
});

export const systemConfigActions = systemConfigSlice.actions;

export default systemConfigSlice.reducer;
